import React, { useState } from "react";
import './WorkExperience.css'

const WorkExperience = () => {
    const [companyDetails] = useState([
        {
            companyLogo: `/booth-logo.png`,
            companyName: "Booth",
            duration: "February, 2026 - Present",
            techStacks: ["FreeMarker", "PrimeFaces", "Spring MVC", "Spring Boot", "Velocity", "Playwright", "JUnit"],
            jobDescription: "At Booth, I work as a Full Stack Developer modernizing legacy applications — migrating them from Velocity to FreeMarker and PrimeFaces within a Spring-based architecture — while strengthening application security and building out automated test coverage.",
            keyResponsibilities: ["Migrate a legacy application from Velocity to FreeMarker templates within a Spring MVC architecture", "Implement multi-factor authentication (MFA) to strengthen application security", "Migrate another application from Velocity to PrimeFaces and Spring Boot", "Add end-to-end testing automation to an existing application using Playwright", "Add unit testing to the application using JUnit"],
        },
        {
            companyLogo: `/cwt-logo.png`,
            companyName: "Carlson Wagonlit",
            duration: "May, 2025 - January 2026",
            techStacks: ["Core Java", "JSP", "Servlet", "Sybase", ".Net Webform 4.5.x"],
            jobDescription: "At CWT, I maintained the client's legacy application. This included bug fixes, updating dependencies, and adding features to the system.",
            keyResponsibilities: ["Maintain the client's legacy application so that their softwares remain compliant", "Implement Manulife API into the system to allow users to purchase Manulife Insurances"],
        },
        {
            companyLogo: `/ibm-logo.png`,
            companyName: "IBM",
            duration: "Nov, 2022 - May 2025",
            techStacks: ["Spring Boot", "Spring Batch", "Spring MVC", "Hibernate", "Spring Actuator", "React JS", "Golang", "MySQL", "Qtest", "Service Now", "Docker", "Control-M", "Postman Scripts", "Docker", "GitlabCI", "Terraform", "AWS Lambda", "AWS DynamoDB", "AWS API Gateway"],
            jobDescription: "At IBM, I work with a wide range of technologies including Spring MVC, Spring Batch, React JS, Golang, MySQL, Qtest, Service Now, Docker, Control-M, AWS Lambda, AWS DynamoDB, and AWS API Gateway. My responsibilities include maintaining client applications to ensure compliance, collaborating with developers both inside and outside the team to create applications, and migrating existing Spring Boot applications to AWS with Golang and Terraform.",
            keyResponsibilities: ["Maintain the client's applications so that their softwares remain compliant", "Collaborate with my fellow devs outside and inside of the team to create the Application", "Migrate the existing Spring Boot application to AWS"],
        },
        {
            companyLogo: `/pearlpay-logo.png`,
            companyName: "Pearlpay",
            duration: "March, 2021 - Nov, 2022",
            techStacks: ["Spring Boot", "Spring MVC", "Spring Data JPA", "JUnit", "Angular JS", "MySQL", "Github", "Pentaho Reports"],
            jobDescription: "As a developer at Pearlpay, I utilized technologies such as Spring MVC, Angular JS, MySQL, and Github to maintain the company's Core Banking Solution. I provided crucial development support during UAT phases to help secure prospective clients. My role also involved assisting new hires to ensure a smooth onboarding process and collaborating closely with QA and fellow developers to maintain and test the application.",
            keyResponsibilities: ["Maintain the Core Banking Solution of the company", "Dev Support during UAT to help the company secure prospect client", "Assist our new hires to make their onboarding smoother", "Collaborate with the QA and fellow Devs to maintain and test the application"],
        }
    ])
    
    return (
        <div className="work-container" id="experience">
            <div className="screen-title">
                <span>__ Work Experience __</span>
            </div>
            {companyDetails.map((company, i) => (
                <div className={`item-container ${i % 2 !== 1 ? 'inverse' : ''}`} key={i}>
                    <div className="experience-card">
                        <div className="logo-container">
                            <img className="logo" src={company.companyLogo} alt={`${company.companyName} logo`}/>
                        </div>
                        <div className="job-container">
                            <div className="job-header">
                                <h1>{company.companyName}</h1>
                                <h3>{company.duration}</h3>
                            </div>
                            
                            <div>
                                <h3 className="section-title">Technologies</h3>
                                <div className="stack-container"> 
                                    {company.techStacks.map((stack, index) => (
                                        <span key={index} className="tech-stack">{stack}</span>
                                    ))}
                                </div>
                            </div>
                            
                            <div>
                                <h3 className="section-title">Overview</h3>
                                <p>{company.jobDescription}</p>
                            </div>
                            
                            <div>
                                <h3 className="section-title">Key Responsibilities</h3>
                                <ul>
                                    {company.keyResponsibilities.map((resp, index) => (
                                        <li key={index}>{resp}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default WorkExperience;